import { requestImagePickerPermissions } from "@utils/Permissions";

/**
 * Requests camera + storage permissions for the image picker.
 * Resolves on success, rejects with an error on denial.
 */
const checkPermissions = async () => {
  const { granted } = await requestImagePickerPermissions();
  if (granted) return;
  throw new Error("permissions not granted");
};

export default checkPermissions;
